import { atom } from 'jotai';

export const isTotalsCalculated = atom<boolean | undefined>();
